import styled from "styled-components"

const ActualiteContainer = styled.article`
  &:not(:last-of-type) {
    border-bottom: 5px solid
      ${(props) => props.theme.a_color_gradients.a_medium};
  }
`
const ActualiteTitle = styled.h3`
  & > a {
    &::before {
      background-color: ${(props) => props.theme.a_color_gradients.a_dark}61;
    }
  }
`

export { ActualiteTitle, ActualiteContainer }
